import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "isFavourite",
  "use": "isFavourite-usage",
  "viewBox": "0 0 21 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 21\" id=\"isFavourite\"><title>isFavourite</title><g id=\"isFavourite_Layer_6\" data-name=\"Layer 6\"><path d=\"M10.5,17.2842a1.3172,1.3172,0,0,1-.9355-.3872L4.3779,11.7334A4.6913,4.6913,0,0,1,10.5,4.6538a4.6915,4.6915,0,0,1,6.1709,7.03l-.0508.0532-5.1855,5.1611A1.3165,1.3165,0,0,1,10.5,17.2842Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/isFavourite.svg
// module id = IRKv
// module chunks = 4